<template>
  <el-container>
    <div class="container">
      <div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" style="width:100%">
          <el-form-item label prop="Mobile">
            <el-input placeholder="请输入手机号" v-model="ruleForm.Mobile" clearable>
              <i slot="prefix" class="el-icon-phone-outline"></i>
            </el-input>
          </el-form-item>
          <el-row>
            <el-col :span="9">
              <el-form-item label prop="verification">
                <el-input v-model.number="ruleForm.verification" placeholder="请输入验证码" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="14" :offset="1">
              <el-button type="primary">
                <span v-show="show" @click="getCode">获取验证码</span>
                <span v-show="!show" class="count">{{count}}s后可重发</span>
              </el-button>
            </el-col>
          </el-row>
          <br />
          <br />
          <el-form-item style="text-align: center">
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
            <el-button type="primary" @click="submitForm(ruleForm)" style="width:100%">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-container>
</template>

<script>
export default {
  name: "index",
  data() {
    // 验证手机号
    function validateaccount(rule, value, callback) {
      var MobileRegex = /^1[3|4|5|7|8][0-9]\d{8}$/;
      if (!MobileRegex.test(value)) {
        callback(new Error("请输入格式正确的手机号码！"));
      } else {
        callback();
      }
    }
    return {
      // 基础数据
      show: true,
      count: "",
      timer: null,
      parent: {
        height: "600px"
      },
      ruleForm: {
        name: "",
        Mobile: "",
        verification: ""
      },
      rules: {
        Mobile: [
          {
            min: 11,
            max: 11,
            message: "请输入格式正确的手机号码",
            trigger: "blur"
          },
          { validator: validateaccount, trigger: "blur" }
        ],
        verification: [
          // { validator: checkAge, trigger: 'blur' }
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      datatime: `${new Date().getFullYear()}-${new Date().getMonth() +
        1}-${new Date().getDate()} ${
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours()
      }:${
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes()
      }:${
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds()
      }`
    };
  },
  mounted() {},
  methods: {
    getheight() {
      // 获取当前屏幕高度
      this.$data.parent.height =
        (window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight) + "px";
      console.log(this.parent.height);
    },
    getCode() {
      // 验证码倒计时
      this.$http
        .get(
          `/mtscitech/back/frontend/smssendauthcode?phoneNo=${this.ruleForm.Mobile}`
        )
        .then(res => {
          console.log(res);
        });
      console.log("1");
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    submitForm(form) {
      // 注册
      this.$http
        .get(
          `/mtscitech/back/frontend/loginByAuthCode?phone=${form.Mobile}&authCode=${form.verification}`
        )
        .then(res => {
          console.log(res);
          if (res.message == "手机验证码登陆接口调用成功") {
            this.$router.push(`/regcode?openid=${window.localStorage.getItem("key")}`);
          } else {
            this.$dialog({
              title: res.message,
              lockBgScroll: false,
              noOkBtn: true,
              cancelBtnTxt: "我知道了",
              content: res.data
            });
          }
        });
    },
    resetForm(formName) {
      // 重置
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style  lang="scss">
h2 {
  font-size: rem(18);
}
.home {
  .top {
    color: #fff;
    font-size: rem(16);
    background: url("../../assets/img/bg.png");
    @include bg();
  }
  .box {
    box-sizing: border-box;
    background: #fff;
    border-radius: rem(5);
    margin: rem(15) rem(10) rem(15) rem(10);
    padding: rem(60) rem(10) rem(80) rem(10);
  }
  .lihieght {
    margin: rem(15) rem(0) rem(15) rem(0);
  }
}
#yzm .nut-textinput input {
  width: 150px;
}
</style>